<template>

  <div id="form-container" ref="formContainer">
      <h1>Application Documents</h1>

      <form-summary ref="errorContainer" id="errorContainer"/>

      <b-row>
          <AppNav :applicationId="appId"></AppNav>
      </b-row>
      <b-form id="pgContainer" tabindex="-1">
          <div class="mt-3 ml-2">
              <p class="red">Please note that all documents uploaded must be one of .pdf, .docx, or .png.</p>
          </div>
          <div v-if="application != null">
              <div class="card">
                <div class="card-header">Application Info</div>
                <div class="card-body">
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Program:</span> {{ application.appName.programNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Type:</span> {{ application.appName.applicationTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Sub Type:</span> {{ application.appName.applicationSubTypeNm }}</b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12"><span class="font-weight-bold">Application Number:</span> {{ application.applicationNumber }}</b-col>
                  </b-row>
                  <b-row v-if="application.hfid">
                    <b-col cols="12" ><span class="font-weight-bold">HFID:</span> {{ application.hfid }}</b-col>
                    <!--<b-col cols="12" v-else><span class="font-weight-bold">License number:</span> {{ application.hfid }}</b-col>-->
                  </b-row>
                  <b-row v-if="displayRevenue()">
                    <b-col cols="12"><span class="font-weight-bold">Revenue:</span> {{ formatCurrency(application.revenue) }}</b-col>
                  </b-row>

                </div>
              </div>
              <div class="card" v-if="!isAdmin() && displayHfid()">
                <div>
                  <div class="card-header">HFID (Health Facility Identification) Number</div>
                  <div class="card-body">
                    <b-form id="card-form-container">
                      <b-row class="align-items-center" cols="12">
                        <b-col cols="3">
                          <form-group>
                            <b-form-input  v-model="application.hfid"
                                           id="hfid"
                                           label="HFID"
                                           label-for="HFID"/>
                          </form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-button @click="saveHFID" class="mr-2 mb-3 btn btn-success">Update HFID</b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </div>
                </div>
              </div>
              <div class="card" v-if="!isAdmin() && displayRevenue()">
                <div class="card-header">Provider Annual Revenue</div>
                <div class="card-body">
                  <b-form id="card-form-container">
                    <b-row class="align-items-center" cols="12">
                      <b-col cols="3">
                        <form-group>
                          <BaseMoneyInput v-model="application.revenue"
                                          :v="$v.application.revenue"
                                          label="Revenue"
                                          slug="revenue"
                                          :setId="'revenue'+index"/>
                        </form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-button @click="saveRevenue" class="mr-2 mb-3 btn btn-success">Update Revenue</b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </div>
              </div>
              <div class="card" v-if="appDocumentType != null">
                  <div class="card-header">Application
                      <span v-if="invalidDocNumbers(appDocumentType)" class="red">
                                  <b-icon icon="exclamation-circle-fill" aria-label="Invalid number of documents uploaded"></b-icon>
                              </span>
                      <span v-if="!invalidDocNumbers(appDocumentType)" class="green">
                                  <b-icon icon="check-circle-fill" aria-label="Valid number of documents uploaded"></b-icon>
                              </span>
                  </div>
                  <div class="card-body">
                      <b-row class="mb-1 mt-1">
                          <b-col cols="9">
                              Upload your application here.  Supplemental documents are shown below.
                          </b-col>
                          <b-col cols="3" class="d-flex align-items-center">
                              <b-button @click="toDoc(appDocumentType)" variant="outline-primary">
                                  Upload
                              </b-button>
                          </b-col>
                      </b-row>
                  </div>
              </div>
              <div class="card">
                  <div class="card-header">Additional Documents</div>
                  <div class="card-body" v-if="documentTypes && documentTypes.length > 0 ">
                      <div v-for="(documentType, index) in documentTypes" :key="documentType.id">
                          <b-row class="mb-1 mt-1">
                              <b-col cols="9" class="font-weight-bold">
                                  {{documentType.name}}
                                  <span v-if="documentType.min > 0">
                                      <span v-if="invalidDocNumbers(documentType)" class="red">
                                            <b-icon icon="exclamation-circle-fill" aria-label="Invalid number of documents uploaded"></b-icon>
                                      </span>
                                      <span v-if="!invalidDocNumbers(documentType)" class="green">
                                            <b-icon icon="check-circle-fill" aria-label="Valid number of documents uploaded"></b-icon>
                                      </span>
                                  </span>
                              </b-col>
                              <b-col cols="3" class="d-flex align-items-center">
                                  <b-button @click="toDoc(documentType)" variant="outline-primary">
                                      Upload
                                  </b-button>
                              </b-col>
                          </b-row>
                          <b-row v-bind:class="{'border-bottom':index !== documentTypes.length-1}" class="pb-2">
                              <b-col>
                                  {{documentType.description}}
                              </b-col>
                          </b-row>
                      </div>
                  </div>
              </div>
          </div>
          <div class="float-right mb-4">
              <b-button type="button" variant="secondary" to="/dashboard" role="button" class="mr-1">Cancel</b-button>
              <b-button @click="submitApplication" variant="primary">
                  Submit Application
              </b-button>
          </div>
      </b-form>

  </div>
</template>

<script>
import axios from 'axios'
import axiosRetry from 'axios-retry'
import {requiredIf, minValue, helpers} from 'vuelidate/lib/validators'
import router from "@/router";
import ConfigService from "@/services/ConfigService";
import AppNav from "@/components/templates/AppNav";
import FormGroup from "@/components/templates/FormGroup.vue";
import BaseMoneyInput from "@/components/templates/input/BaseMoneyInput.vue";
import {regex} from "vuelidate/lib/validators/common";

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  })

export default {
    components: {BaseMoneyInput, FormGroup, AppNav},
    data: () => ({
    application: null,
    appId: null,
    documentTypes: [],
    appDocumentType: null,
    appDocs:[],
  }),
  created() {
    document.title = "Application Documents - Facility and Provider Licensing System",
    this.appId = this.$route.params.id
    this.loadApplication()
    this.loadDocTypes()
    this.loadDocNumbers()
  },
  mounted() {
      document.getElementById('pgContainer').focus()
  },
  methods: {
    loadApplication() {
      axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId)
      .then(response => {
        this.application = response.data
      })
    },
    loadDocTypes() {
      axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + '/document-types/')
      .then(response => {
        this.appDocumentType = response.data[0]
        this.documentTypes = response.data.slice(1)
      })
    },
    loadDocNumbers() {
        const payload = {
            documentTypeId: ''
        }
        axios.get(ConfigService.getApiUrl() + `/api/applications/`+ this.appId + "/documents", {params: payload})
            .then(response => {
                this.appDocs = response.data
            })
    },
    saveRevenue() {
      this.$v.application.revenue.$touch();

      if (!this.$v.application.revenue.$invalid) {
        axios.post(ConfigService.getApiUrl() + `/api/applications/`+ this.application.id + '/revenue', this.application.revenue)
            .then(response => {
              this.showRootToast("Saved", "Revenue amount saved", "success")
            })
      } else {
        this.$nextTick(() => {
          document.getElementById('form-container').scrollIntoView()
        })
      }
    },
    saveHFID() {
      this.$v.application.hfid.$touch();
      console.log(this.$v.application)
      if (!this.$v.application.hfid.$invalid) {
        const payload = {
          hfid: this.application.hfid
        }
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.application.id + '/hfid', payload)
            .then(response => {
              this.showRootToast("Saved", "HFID saved", "success")
            })
      } else {
        this.$nextTick(() => {
          this.showRootToast("Error", this.$v.application.hfid.$params.isFiveDigits.type, "danger")
          document.getElementById('form-container').scrollIntoView()
        })
      }
    },
    saveApplication() {
        axios.put(ConfigService.getApiUrl() + `/api/applications/`+this.application.id, this.application)
            .then(response => {
                this.showRootToast("Saved", "Application saved", "success")
            })
    },
    submitApplication() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$nextTick(() => {
          document.getElementById('form-container').scrollIntoView()
        })
        return
      }
      this.saveApplication()
        axios.post(ConfigService.getApiUrl() + `/api/applications/` + this.application.id + '/submit')
            .then(response => {
                this.showRootToast("Submitted", "Application successfully submitted", "success")
                setTimeout(() => {
                    router.push("/dashboard")
                }, 200)
            }).catch(err => {
                if (err.response) {
                  let errorList = Object.values(err.response.data)
                  this.showRootToast("Error", this.createErrorToast(errorList),
                          "danger")
                } else {
                  this.showRootToast("Error", "Application was unable to connect.  Please try again later.",
                          "danger")
                }
        })
    },
    isAdmin(){
      if (this.$keycloak) {
        return this.$keycloak.hasResourceRole("ADMIN", ConfigService.getBackendClientName())
      } else {
        return false;
      }
    },
    displayHfid(){
      //applicants for these programs should NOT be able to enter a hfid, that will be done by admin role
      return !(this.application.appName.programNm.includes('Provisional') || this.application.appName.programNm.includes('Temporary'))

    },
    displayRevenue(){
      return (this.application.appName.programNm.includes('Home and Community-Based Services') && this.application.appName.applicationTypeNm.includes('Renewal'))
    },
    formatCurrency(value) {
      if (typeof value !== "number") return "";
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(value);
    },
    toDoc(documentType) {
        router.push({
            name: 'document',
            params: {
                application: this.application,
                documentType: documentType
            }
        })
    },
    invalidDocNumbers(documentType) {
      let filtered = this.appDocs.filter(d => d.documentTypeId === documentType.id);
      return (filtered.length > documentType.max || filtered.length < documentType.min)
    },
    createErrorToast(errors) {
        const h = this.$createElement
        const errNodes = h(
            'div',
            [
                h('p','Application contains errors, please fix and resubmit'),
                h('ul', [
                    errors.map(e => {
                        return h('li', {attrs:{class: 'circle-list ml-4'}}, e)
                    })
                ])
            ]
        )
        return errNodes
    },
    showRootToast(title, message, type) {
        this.$root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: type,
            appendToast: true,
            noAutoHide:true
        })
        this.toastFocus()
    },
    toastFocus() {
        setTimeout(() => {
            let elem = document.getElementsByClassName("toast")
            elem = elem[elem.length-1]
            elem.focus()
        }, 100)
    },
  },
  validations() {
    return {
      application: {
        revenue: {
          //TODO: TEST this with out app types AND custom message for minValue
          required: requiredIf(function() {
            return this.application.appName.programNm.includes("Home and Community-Based Services")
                && this.application.appName.applicationTypeNm.includes("Renewal")
          }),
          minValue: minValue(0.00000001)
        },
        hfid: {
          isFiveDigits: helpers.regex('HFID must be 5 digits.', /^\d{5}$/)
        }
      }
    }
  },
}
</script>
<style>
    .circle-list {
        list-style-type: circle;
        display: list-item;
    }
</style>
